export const invitationGerman = {
  action: 'Einladungslink zum Weitergeben erzeugen',
  title: 'Einladungslink weitergeben',
  description: 'Für {{name}} · {{email}}. Es wird keine E-Mail versendet.',
  warning:
    'Ein neuer Link macht alle bisherigen Einladungslinks dieses Kontos ungültig, auch bereits weitergegebene.',
  initial:
    'Erzeugen Sie den Link bewusst und geben Sie ihn nur an diese Person weiter. Passwortvergabe und Zwei-Faktor-Anmeldung bleiben unverändert.',
  generate: 'Link erzeugen',
  regenerate: 'Neuen Link erzeugen',
  generating: 'Link wird erzeugt …',
  copy: 'Link kopieren',
  copied: 'Link kopiert',
  copyFailed: 'Kopieren war nicht möglich. Markieren Sie den Link und kopieren Sie ihn manuell.',
  link: 'Einladungslink',
  expires: 'Gültig bis {{date}}',
  expired: 'Dieser Link ist abgelaufen. Erzeugen Sie bei Bedarf einen neuen Link.',
  transient:
    'Der Link wird nur hier angezeigt. Nach dem Schließen können Sie einen neuen Link erzeugen.',
  failed:
    'Der Link konnte nicht erzeugt werden. Laden Sie die Benutzerliste neu und prüfen Sie den Zugang.',
  unknown:
    'Der Ausgang ist unklar. Ein neuer Link könnte bereits erzeugt worden sein. Erzeugen Sie bewusst einen neuen Link; frühere Links werden dadurch ungültig.',
  offline:
    'Keine Verbindung. Stellen Sie die Verbindung wieder her, bevor Sie einen Link erzeugen.',
  close: 'Schließen',
};

export const invitationEnglish = {
  action: 'Generate invitation link to share',
  title: 'Share invitation link',
  description: 'For {{name}} · {{email}}. No email will be sent.',
  warning:
    'A new link invalidates all earlier invitation links for this account, including links already shared.',
  initial:
    'Generate the link explicitly and share it only with this person. Password setup and two-factor authentication remain unchanged.',
  generate: 'Generate link',
  regenerate: 'Generate new link',
  generating: 'Generating link …',
  copy: 'Copy link',
  copied: 'Link copied',
  copyFailed: 'Could not copy. Select the link and copy it manually.',
  link: 'Invitation link',
  expires: 'Valid until {{date}}',
  expired: 'This link has expired. Generate a new link if needed.',
  transient: 'The link is shown only here. After closing, you can generate a new link.',
  failed: 'Could not generate the link. Reload the user list and check access.',
  unknown:
    'The outcome is unknown. A new link may already have been generated. Explicitly generate a new link; this invalidates earlier links.',
  offline: 'No connection. Reconnect before generating a link.',
  close: 'Close',
};
